function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -11 464 463",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m294.710938 330.625 8.324218-8.324219c.652344-.652343 1.707032-.652343 2.359375 0l9.945313 9.949219c.652344.652344 1.707031.652344 2.359375 0l14.050781-14.050781c.652344-.652344.652344-1.707031 0-2.359375l-9.949219-9.945313c-.652343-.652343-.652343-1.707031 0-2.359375l8.324219-8.324218c1.113281-1.113282.421875-3.019532-1.144531-3.160157l-38.953125-3.542969c-1.15625-.105468-2.125.863282-2.019532 2.015626l3.542969 38.957031c.140625 1.566406 2.046875 2.257812 3.160157 1.144531zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 392.238281h-39.554688l-.414062-215.773437c-.023438-13.214844-10.796875-23.964844-24.015625-23.964844h-320.476563c-13.234374 0-24 10.765625-24 24v215.738281h-39.539062c-4.421875 0-8 3.582031-8 8v16.511719c0 13.097656 10.65625 23.75 23.75 23.75h416.25c13.234375 0 24-10.765625 24-24v-16.261719c0-4.417969-3.578125-8-8-8zm-392.460938-215.738281c0-4.410156 3.585938-8 8-8h320.476563c4.414063 0 8.007813 3.585938 8.015625 7.996094l.414062 215.742187h-124.445312c-4.421875 0-8 3.582031-8 8h-72c0-4.417969-3.578125-8-8-8h-124.460938zm384.460938 240c0 4.410156-3.585938 8-8 8h-416.25c-4.273438 0-7.75-3.476562-7.75-7.75v-8.511719h166.148438c2.765624 4.777344 7.9375 8 13.851562 8h72c5.914062 0 11.085938-3.222656 13.851562-8h166.148438zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.5 288.371094h7c7.171875 0 13 5.832031 13 13 0 7.167968-5.828125 13-13 13h-21c-4.421875 0-8 3.582031-8 8 0 4.417968 3.578125 8 8 8h9.5v6c0 4.417968 3.578125 8 8 8s8-3.582032 8-8v-6.453125c13.847656-2.183594 24.5-14.097657 24.5-28.546875 0-15.992188-13.007812-29-29-29h-7c-7.171875 0-13-5.832032-13-13 0-7.167969 5.828125-13 13-13h17.5c4.421875 0 8-3.582032 8-8 0-4.417969-3.578125-8-8-8h-6v-6c0-4.417969-3.578125-8-8-8s-8 3.582031-8 8v6.457031c-13.847656 2.179687-24.5 14.09375-24.5 28.542969 0 15.992187 13.007812 29 29 29zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 368.5v-176c0-4.414062-3.578125-7.996094-7.992188-8l-288-.261719h-.007812c-2.117188 0-4.15625.84375-5.65625 2.339844-1.5 1.5-2.34375 3.539063-2.34375 5.660156v176.132813c0 8.039062 0 8.039062 52.992188 8.074218l243.007812.054688c4.421875 0 8-3.582031 8-8zm-16-8c-88.09375 0-236.460938-.023438-272-.09375v-160.160156l272 .246094zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 224.5c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 224.5c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 224.5c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 96.5c4.421875 0 8-3.582031 8-8v-80c0-4.417969-3.578125-8-8-8s-8 3.582031-8 8v80c0 4.417969 3.578125 8 8 8zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.125 118.652344c1.492188 2.515625 4.15625 3.914062 6.882812 3.914062 1.390626 0 2.796876-.359375 4.078126-1.121094 3.796874-2.257812 5.046874-7.167968 2.789062-10.964843l-44-74.066407c-2.25-3.800781-7.164062-5.054687-10.960938-2.792968-3.796874 2.257812-5.046874 7.167968-2.789062 10.964844zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.914062 121.445312c1.28125.761719 2.6875 1.121094 4.078126 1.121094 2.726562 0 5.390624-1.398437 6.882812-3.914062l44-74.066406c2.257812-3.796876 1.007812-8.707032-2.789062-10.964844-3.796876-2.261719-8.703126-1.007813-10.960938 2.792968l-44 74.066407c-2.257812 3.796875-1.007812 8.707031 2.789062 10.964843zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.be1e7b214d2e0af23e35f9b8c649b522.svg";
export { ForwardRef as ReactComponent };